import { Api } from './axios-config';

export interface IClientPackageView {
  id: number;
  servicePackageId: number;
  packageName: string;
  userId: number;
  userName: string;
  businessId: number;
  businessName: string;
  remainingUses: number;
  totalUses: number;
  usesUsed: number;
  purchasedAt: Date;
  expiresAt?: Date;
  active: boolean;
  serviceId: number;
  serviceName: string;
  paymentMethod?: string;
  cycle: number;
  packageGroupId: string;
  status: 'Active' | 'Pending' | 'Inactive';
  packageAmount: number;
}

export interface ICreateClientPackage {
  servicePackageId: number;
  userId: number;
  businessId: number;
  paymentMethod?: string;
  sellerBusinessEmployeeId?: number;
}

export interface IRenewClientPackage {
  paymentMethod?: string;
  sellerBusinessEmployeeId?: number;
}

const getById = async (id: number): Promise<IClientPackageView> => {
  try {
    const { data } = await Api.get<IClientPackageView>(`/clientPackage/${id}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getByClient = async (userId: number, businessId: number): Promise<IClientPackageView[]> => {
  try {
    const { data } = await Api.get<IClientPackageView[]>(`/clientPackage/client/${userId}/${businessId}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getByBusiness = async (businessId: number): Promise<IClientPackageView[]> => {
  try {
    const { data } = await Api.get<IClientPackageView[]>(`/clientPackage/business/${businessId}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getMyPackages = async (): Promise<IClientPackageView[]> => {
  try {
    const { data } = await Api.get<IClientPackageView[]>('/clientPackage/me');
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const sell = async (body: ICreateClientPackage): Promise<number> => {
  try {
    const { data } = await Api.post('/clientPackage/sell', body);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const renew = async (id: number, body: IRenewClientPackage): Promise<number> => {
  try {
    const { data } = await Api.post(`/clientPackage/${id}/renew`, body);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getByPackage = async (servicePackageId: number): Promise<IClientPackageView[]> => {
  try {
    const { data } = await Api.get<IClientPackageView[]>(`/clientPackage/package/${servicePackageId}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getByClientAll = async (userId: number, businessId: number): Promise<IClientPackageView[]> => {
  try {
    const { data } = await Api.get<IClientPackageView[]>(`/clientPackage/client/${userId}/${businessId}/all`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const toggleActive = async (id: number): Promise<void> => {
  try {
    await Api.patch(`/clientPackage/${id}/toggle-active`);
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const clientPackageService = {
  getById,
  getByClient,
  getByBusiness,
  getMyPackages,
  sell,
  renew,
  getByPackage,
  getByClientAll,
  toggleActive,
};
